import { Breadcrumb } from "@gull";
import { AppContext } from "app/appContext";
import { useContext } from "react";
import { Helmet } from "react-helmet";

/* ------------------------------------------------------------------ */
/* Constants                                                           */
/* ------------------------------------------------------------------ */

import FlightBookingDashboard from "./Components/Flight/FlightBookingDashboard";

export default function FlightBookingDashboardApi() {
  const { user } = useContext(AppContext);
  return (
    <>
      <Helmet>
        <title>Admin Dashboard</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Dashboard - " + (user?.name || "") }]}
      />
      <FlightBookingDashboard />
    </>
  );
}
